"use client";
import type { OnChangeFn, SortingState } from "@tanstack/react-table";
import {
  createContext,
  type PropsWithChildren,
  useMemo,
  useState
} from "react";

export const sortingContext = createContext<SortingContext | undefined>(
  undefined
);

type SortingOrder = "asc" | "desc" | undefined;

export type SortingContext = {
  sortingState: SortingState;
  onSortingChange: OnChangeFn<SortingState>;
  sortingOrder: SortingOrder;
  sortedColumnId: string | undefined;
};

export function SortingContextProvider(props: PropsWithChildren) {
  const [sortingState, setSortingState] = useState<SortingState>([]);

  const sortingOrder: SortingOrder = useMemo(() => {
    if (sortingState.length === 0) return undefined;
    return sortingState[0].desc ? "desc" : "asc";
  }, [sortingState]);

  const values = useMemo(
    () => ({
      sortingState,
      onSortingChange: setSortingState,
      sortingOrder,
      sortedColumnId: sortingState.length === 0 ? undefined : sortingState[0].id
    }),
    [sortingOrder, sortingState]
  );

  return (
    <sortingContext.Provider value={values}>
      {props.children}
    </sortingContext.Provider>
  );
}
